import React from 'react';
import classNames from 'classnames';
import _isEmpty from 'lodash/isEmpty';
import isEmpty from 'lodash/isEmpty';

import { SideCard } from 'components/cards/cmpSideCard';
import SalaryCalculator from 'components/salaryCalculator';
import { formatCurrency, importStatic, scrollTo } from 'utils';

import styles from '../../../css/salaryJobPage.module.css';

const Sidebar = ({
  jobTitle,
  geoLocation,
  salaryByGender,
  hasSalaryReport,
  entryLevelSalary,
  disableLinks,
  salaryCalculatorDismissible = false,
  jobTitlePlural,
  salaryByEthnicity,
  nonSticky = false,
  salaryCalculatorTitleTagName,
  salaryCalloutsrc,
}) => {
  const getGenderPayGap = () => {
    if (!isEmpty(salaryByGender)) {
      const female = salaryByGender?.Female;
      const male = salaryByGender?.Male;
      return (
        <div className="font-weight-normal">
          Women earn <strong>${Math.round((female / male) * 100)}¢</strong> for every{' '}
          <strong>$1</strong> earned by men
        </div>
      );
    } else {
      return '';
    }
  };

  const highestPaidRace =
    !_isEmpty(salaryByEthnicity) &&
    Object.keys(salaryByEthnicity).reduce((p, v) =>
      salaryByEthnicity[p] > salaryByEthnicity[v] ? p : v
    );
  const lowestPaidRace =
    !_isEmpty(salaryByEthnicity) &&
    Object.keys(salaryByEthnicity).reduce((p, v) =>
      salaryByEthnicity[p] < salaryByEthnicity[v] ? p : v
    );

  const handleScrolling = (id) => {
    const elem = document.getElementById(id);
    if (elem) {
      scrollTo('#' + id, 1200, true);
    }
  };

  const sideBarData = [];

  if (entryLevelSalary) {
    sideBarData.push({
      title: 'Entry-Level Salary',
      value: formatCurrency(entryLevelSalary),
      icon: importStatic('/ui-router/images/entry-level-salary.svg'),
      onClick: () => handleScrolling('salary-by-experience-level'),
      isDisabled: disableLinks,
    });
  }

  if (!_isEmpty(salaryByGender)) {
    sideBarData.push({
      title: 'Gender Pay Gap',
      value: getGenderPayGap(),
      icon: importStatic('/ui-router/images/genderRatioMale.svg'),
      onClick: () => handleScrolling('salary-demographics'),
      isDisabled: disableLinks,
    });
  }

  if (lowestPaidRace && highestPaidRace) {
    sideBarData.push({
      title: 'Racial Pay Gap',
      onClick: () => handleScrolling('salary-demographics-race'),
      value: (
        <div className="font-weight-normal">
          {lowestPaidRace} {jobTitlePlural} earn{' '}
          <strong>
            {Math.round(
              (salaryByEthnicity[lowestPaidRace] / salaryByEthnicity[highestPaidRace]) * 100
            )}
            ¢
          </strong>{' '}
          for every <strong>$1</strong> earned by {highestPaidRace} {jobTitlePlural}
        </div>
      ),
      icon: `/ui-router/images/career-demographics/race.svg`,
      isDisabled: disableLinks,
    });
  }

  return (
    <aside className="h-100">
      {sideBarData.map((propData, index) => (
        <SideCard noShadow {...propData} key={propData.title + index} />
      ))}
      {!hasSalaryReport && (
        <div
          className={classNames({
            [styles['salary-calculator-sticky']]: !nonSticky && !salaryCalculatorDismissible,
            'mt-5': !!sideBarData?.length,
          })}
        >
          <SalaryCalculator
            titlePrefillValue={jobTitle}
            locationPrefillValue={geoLocation}
            dismissible={salaryCalculatorDismissible}
            calloutLocation="average-salary-chart"
            TitleTagName={salaryCalculatorTitleTagName}
            src={salaryCalloutsrc}
          />
        </div>
      )}
    </aside>
  );
};

export default Sidebar;
